import { defineMessages } from 'react-intl';

const _default_1: {
	closePreviewLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	closePreviewLabel: {
		id: 'fabric.editor.ai.components.closePreviewIconButton.closePreviewLabel.non-final',
		defaultMessage: 'Close preview',
		description:
			'Label and tooltip text for the icon button that closes the AI-generated content preview in the generative AI modal.',
	},
});
export default _default_1;
